var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.isActive)?_c('div',{staticClass:"carousel-content-background",domProps:{"innerHTML":_vm._s(_vm.content.image)}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }